import React, { memo } from "react";

import { Skeleton } from "components";
import { useLoader } from "hooks";
import { DatePickerInputProps } from "types";

type DatePickerWithLoaderWrapperProps = {
	input?: DatePickerInputProps;
	isLoading: boolean;
	renderDatePicker: (input?: DatePickerInputProps) => JSX.Element;
};

const DatePickerWithLoaderWrapper = ({
	input,
	isLoading,
	renderDatePicker,
}: DatePickerWithLoaderWrapperProps) => {
	const component = renderDatePicker(input);
	const Loader = useLoader(isLoading);

	return <Loader skeleton={<Skeleton height={34} />} component={component} />;
};

export default memo(DatePickerWithLoaderWrapper);
